module.exports = __webpack_public_path__ + "img/bar.179e480c.png";